(ns practitest.frontend.components2.dashboard.charts.marks-gen
  (:require ["d3" :as d3]))

(defn- accessor [{:keys [field]}]
  (fn [d] (aget d (name field))))

(defn project-x [{{:keys [x]} :encode}]
  (let [getter (accessor x)
        scale  (:d3-scale x)]
    (fn [d] (scale (getter d)))))

(defn project-y [{{:keys [y]} :encode}]
  (let [getter (accessor y)
        scale  (:d3-scale y)]
    (fn [d] (scale (getter d)))))

(defn line [ctx]
  (-> (.line d3)
      (.x (project-x ctx))
      (.y (project-y ctx))))

(defn area [x-mid y-scale]
  (-> (.area d3)
      (.x x-mid)
      (.y0 (fn [^js d] (y-scale (aget d 0))))
      (.y1 (fn [^js d] (y-scale (aget d 1))))))

(defn area-flat [x-mid baseline-y]
  (-> (.area d3)
      (.x x-mid)
      (.y0 (fn [_] baseline-y))
      (.y1 (fn [_] baseline-y))))
